export interface SiteMap {
  path: string;
  title: string;
  host: string;
}

const ASIAL_HP = 'https://www.asial.co.jp';
const ASIAL_BLOG = 'https://blog.asial.co.jp';

export const EXTERNAL_URL = {
  ASIAL_HP,
  ASIAL_BLOG,
  CASUAL_INTERVIEW: 'https://herp.careers/v1/asial/NTc-UPYIX8hE',
  OBJECTIVE_FS: 'https://objectivefs.jp/',
  MONACA: 'https://ja.monaca.io/',
  MONACA_EDUCATION: 'https://edu.monaca.io/',
  MONACA_FOR_HYBRIDCAST: 'https://hc.monaca.mobi/',
  ONSEN_UI: 'https://ja.onsen.io/',
  MY_CAMPUS: 'https://www.asial.co.jp/campusdx/service/mycampus/',
  JP_GRAPH: 'https://jpgraph.asial.co.jp/',
  OBJECTIVE_FS_CONTACT: 'https://objectivefs.jp/inquiry',
  MONACA_CONTACT: 'https://ja.monaca.io/support/inquiry.html',
  MONACA_EDUCATION_CONTACT: 'https://form.k3r.jp/asial/inquiry',
  ONSEN_UI_CONTACT: 'https://ja.monaca.io/support/inquiry.html',
  ASIAL_EDU_LAB: 'https://edu.monaca.io/',
  NOTE_INTRODUCTION: 'https://note.asial.co.jp/n/nff36430934f0',
  ASIAL_NOTE: 'https://note.asial.co.jp',
  WEBTUB: 'https://medium.com/the-web-tub',
  PUYOPUYO_PROGRAMING: 'https://puyo.sega.jp/program_2020/',
  HTML5_AWARD: 'https://html5award.com/',
  ASIAL_EN: 'https://en.asial.co.jp/'
};

export const STATIC_SITE_MAP: { [k: string]: SiteMap } = {
  HOME: { path: '/', title: 'ホーム', host: ASIAL_HP },
  STRENGTHS: { path: '/strengths/', title: '選ばれる理由', host: ASIAL_HP },
  SOLUTIONS: { path: '/solution/', title: 'ソリューション', host: ASIAL_HP },
  SOLUTIONS_EDUCATION: {
    path: '/solution/education/',
    title: '情報教育',
    host: ASIAL_HP
  },
  SOLUTIONS_UNIVERSITY_DX: {
    path: 'https://www.asial.co.jp/campusdx/',
    title: '大学DX支援',
    host: ASIAL_HP,
  },
  SOLUTIONS_SYSTEM_CONSULTING: { 
    path: '/solution/system-consulting/', 
    title: 'システムコンサルティング', 
    host: ASIAL_HP 
  },
  SOLUTIONS_DX: { path: '/solution/dx/', title: 'DX・内製化支援', host: ASIAL_HP },
  SOLUTIONS_UX_UI: { path: '/solution/ux-ui/', title: 'UX/UIデザイン', host: ASIAL_HP },
  SOLUTIONS_DEVELOPMENT: {
    path: '/solution/system/',
    title: 'システム構築・アプリ開発',
    host: ASIAL_HP
  },
  SOLUTIONS_AI_RD: { path: '/solution/ai-r&d/', title: 'AIシステム開発・R&D', host: ASIAL_HP },
  SOLUTIONS_GLOBALIZE: {
    path: '/solution/globalize/',
    title: 'グローバル展開・ローカライズ',
    host: ASIAL_HP
  },
  PRODUCTS: { path: '/products/', title: 'プロダクト', host: ASIAL_HP },
  WORKS: { path: '/our-works/', title: '実績', host: ASIAL_HP },
  WORKS_WITH_FILTER: { path: '/our-works/filter/', title: '絞り込み', host: ASIAL_HP },
  COMPANY: { path: '/company/', title: '会社情報', host: ASIAL_HP },
  COMPANY_MEMBERS: { path: '/company/members/', title: 'メンバー紹介', host: ASIAL_HP },
  COMPANY_INFORMATION: {
    path: '/company/information/',
    title: '会社概要・沿革',
    host: ASIAL_HP
  },
  COMPANY_CLIENTS: { path: '/company/clients/', title: '取引先一覧', host: ASIAL_HP },
  COMPANY_NEWS: { path: '/company/news/', title: 'ニュース', host: ASIAL_HP },
  COMPANY_NEWS_TOP: { path: '/company/news/all/1/', title: 'ニュース', host: ASIAL_HP },
  CAREERS: { path: '/careers/', title: '採用情報', host: ASIAL_HP },
  CAREERS_INTERVIEWS: {
    path: '/careers/interviews/',
    title: 'メンバーインタビュー',
    host: ASIAL_HP
  },
  CAREERS_STORIES: { path: '/careers/stories/', title: '成長ストーリー', host: ASIAL_HP },
  CAREERS_WORKSTYLE: { path: '/careers/workstyle/', title: '働く環境・制度', host: ASIAL_HP },
  CAREERS_JOBS: { path: '/careers/jobs/', title: '募集要項', host: ASIAL_HP },
  CONTACT: { path: '/contact/', title: 'お問い合わせ', host: ASIAL_HP },
  CONTACT_FORM: { path: '/contact/form/', title: 'お問い合わせフォーム', host: ASIAL_HP },
  PRIVACY_POLICY: { path: '/privacy-policy/', title: 'プライバシーポリシー', host: ASIAL_HP },
  SITE_POLICY: { path: '/site-policy/', title: 'サイトポリシー', host: ASIAL_HP },
  INFORMATION_SECURITY_POLICY: { path: '/information-security-policy/', title: '情報セキュリティ基本方針', host: ASIAL_HP },
  QUALITY_POLICY: { path: '/quality-policy/', title: '品質方針', host: ASIAL_HP },
  SUBSCRIBE: { path: '/subscribe/', title: 'メール購読', host: ASIAL_HP },
  PROFILE_PDF: { path: '/pdf/corporateprofile.pdf', title: '会社案内', host: ASIAL_HP },
  ENGINEER_RECRUITEMENT_PDF: { path: '/pdf/engineer_recruitment.pdf', title: 'エンジニア職向け採用説明資料', host: ASIAL_HP }
};
